import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Btn, Modal, Input, Field } from "@/components/erp/ui";
import { Globe, Eye, EyeOff } from "lucide-react";

const msg = (e) => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Gagal");

// Pengaturan halaman katalog publik (/katalog)
export const PublicCatalogBtn = () => {
  const [f, setF] = useState(null);
  const open = () => api.get("/settings/public-catalog").then(({ data }) => setF(data)).catch((e) => toast.error(msg(e)));
  const save = async () => { try { setF(await api.put("/settings/public-catalog", f).then((r) => r.data)); toast.success("Pengaturan katalog publik disimpan"); } catch (e) { toast.error(msg(e)); } };
  const url = `${window.location.origin}/katalog`;
  return (
    <>
      <Btn variant="ghost" data-testid="public-catalog-btn" onClick={open}><Globe className="w-4 h-4" /> Katalog Publik</Btn>
      <Modal open={!!f} onClose={() => setF(null)} title="Katalog Produk Publik" footer={<Btn data-testid="pubcat-save" onClick={save}>Simpan</Btn>}>
        {f && <div className="space-y-2">
          <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-2 text-xs"><span className="font-mono break-all" data-testid="pubcat-url">{url}</span> · <a href={url} target="_blank" rel="noreferrer" className="text-sky-700 underline" data-testid="pubcat-open">Buka</a> · <button type="button" className="text-sky-700 underline" data-testid="pubcat-copy" onClick={() => { navigator.clipboard?.writeText(url); toast.success("Link disalin"); }}>Salin</button></div>
          <p className="text-xs text-slate-500">Hanya varian yang ditandai <b>Publik</b> yang tampil. Harga = harga dasar katalog.</p>
          <Field label="Judul halaman"><Input data-testid="pubcat-title" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} /></Field>
          <Field label="Kalimat pembuka"><Input data-testid="pubcat-intro" value={f.intro} onChange={(e) => setF({ ...f, intro: e.target.value })} /></Field>
          <Field label="No. WA untuk pesan"><Input data-testid="pubcat-wa" value={f.wa} onChange={(e) => setF({ ...f, wa: e.target.value })} placeholder="08xxxxxxxxxx" /></Field>
        </div>}
      </Modal>
    </>
  );
};

export const PublicToggle = ({ v, onChanged }) => {
  const pub = v.is_public !== false;
  const toggle = async () => { try { await api.put(`/catalog/variants/${v.id}/public`, { is_public: !pub }); toast.success(pub ? "Disembunyikan dari katalog publik" : "Tampil di katalog publik"); onChanged(); } catch (e) { toast.error(msg(e)); } };
  return <Btn variant="ghost" className={`!py-1 !px-2 !text-xs ${pub ? "!text-emerald-700 !border-emerald-300" : ""}`} data-testid={`public-variant-${v.id}`} onClick={toggle}>{pub ? <Eye className="w-3.5 h-3.5" /> : <EyeOff className="w-3.5 h-3.5" />} {pub ? "Publik" : "Tidak publik"}</Btn>;
};
